import { Space, Typography } from "antd";
import React, { Component } from "react";
import nadunetSignature from "../../../assets/img/signature.png";

class BusinessSignature extends Component {
  render() {
    return (
      <Space
        style={{
          margin: "70px 0px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        <Space
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h6>FIRMA NADUNET</h6>
          <img
            style={{
              height: "100%",
              maxHeight: "240px",
              maxWidth: "50%",
              width: "auto",
              pointerEvents: "none",
            }}
            src={nadunetSignature}
            alt="Nadunet CEO signature image"
          />
          <Space direction="vertical">
            <Typography>CEO Adrián Duque Girón</Typography>
            <Typography>Nadunet Telecom SL (B98916133)</Typography>
          </Space>
        </Space>
        <Space
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <h6>FIRMA CLIENTE</h6>
          <img
            style={{
              height: "100%",
              maxHeight: "160px",
              maxWidth: "370px",
              width: "auto",
              pointerEvents: "none",
            }}
            src={this.props.userData.signature}
            alt="Client signature image"
          />
          <Space direction="vertical">
            <Typography>{`${this.props.userData.customer.manager.name} ${this.props.userData.customer.manager.lastName} ${this.props.userData.customer.manager.lastName2}`}</Typography>
            <Typography>
              {`${this.props.userData.customer.businessName} (${this.props.userData.customer.nif})`}
            </Typography>
          </Space>
        </Space>
      </Space>
    );
  }
}

export default BusinessSignature;



// WEBPACK FOOTER //
// ./src/views/Contract/components/BusinessSignature.jsx